export const DealerCreditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="24"
      viewBox="0 0 38 24"
      fill="none"
    >
      <path
        d="M37.1426 9.29102V20.5713C37.1426 21.1224 36.9158 21.6815 36.4629 22.1465L36.2559 22.3398C35.66 22.8417 34.8242 23.1425 33.9287 23.1426H4.07129C3.28756 23.1426 2.54989 22.9125 1.97852 22.5186L1.74414 22.3398C1.1529 21.8418 0.857422 21.2009 0.857422 20.5713V9.29102H37.1426ZM25.7861 14.8574C25.2312 14.8574 24.6777 15.0186 24.2227 15.333L24.0342 15.4775C23.5442 15.8902 23.2325 16.4844 23.2324 17.1426C23.2324 17.7186 23.4705 18.2462 23.8584 18.6455L24.0342 18.8086C24.5199 19.2176 25.152 19.4287 25.7861 19.4287H29.8574C30.4121 19.4287 30.965 19.2673 31.4199 18.9531L31.6084 18.8086C32.0986 18.3958 32.4111 17.801 32.4111 17.1426C32.4111 16.5667 32.172 16.0399 31.7842 15.6406L31.6084 15.4775C31.1227 15.0685 30.4915 14.8575 29.8574 14.8574H25.7861ZM4.07129 0.857422H33.9287C34.7124 0.857449 35.4501 1.08753 36.0215 1.48145L36.2559 1.66016C36.8471 2.15823 37.1426 2.79907 37.1426 3.42871V4.71973H0.857422V3.42871L0.871094 3.19238C0.926541 2.71972 1.14885 2.25211 1.53711 1.85352L1.74414 1.66016C2.26569 1.22096 2.97109 0.935464 3.73926 0.871094L4.07129 0.857422Z"
        fill="#1E1E1E"
        stroke="#1E1E1E"
        strokeWidth="1.71429"
      />
    </svg>
  );
};
